<button mat-button (click)="addNewList()" ><i class="fa fa-plus"></i><span>New List</span></button>